import { Card, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Apps, Bookmarks } from "../../../Constants/Constants";
import { Fragment } from "react/jsx-runtime";
import Sidebar from "./Sidebar/Sidebar";
import BookmarksTabs from "./BookmarksTabs/BookmarksTabs";

const BookmarkContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Bookmarks} parent={Apps} />
      <Container fluid>
        <div className="email-wrap bookmark-wrap">
          <Row>
            <Sidebar />
            <Col xl="9" md="12" className="box-col-12">
              <div className="email-right-aside bookmark-tabcontent">
                <Card className="email-body radius-left">
                  <div className="ps-0">
                    <BookmarksTabs />
                  </div>
                </Card>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default BookmarkContainer;
